import React from 'react';
import { CheckboxField } from '@zola/zola-ui/src/components/Form/CheckboxField';
import { FilterOption } from './Menu.style';
import { ActiveFilters } from '../FilterTypes';

interface OrientationMenuProps {
  activeFilters: Pick<ActiveFilters, 'is_landscape' | 'is_portrait'>;
  updateFilter: (filter: 'is_landscape' | 'is_portrait', value: boolean) => void;
}

export const OrientationMenu: React.FC<OrientationMenuProps> = ({
  activeFilters,
  updateFilter,
}) => (
  <>
    <FilterOption>
      <CheckboxField
        label="Landscape"
        id="landscape"
        type="checkbox"
        checked={activeFilters.is_landscape}
        onChange={() => updateFilter('is_landscape', !activeFilters.is_landscape)}
        meta={{ touched: true }}
      />
    </FilterOption>
    <FilterOption>
      <CheckboxField
        label="Portrait"
        id="portrait"
        type="checkbox"
        checked={activeFilters.is_portrait}
        onChange={() => updateFilter('is_portrait', !activeFilters.is_portrait)}
        meta={{ touched: true }}
      />
    </FilterOption>
  </>
);
